import Vue from 'vue'
import Vuex from 'vuex'
import set from 'lodash/set'
import { storage } from './plugins'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    asnOrderLines: null,
    portal: '',
    user: { },
    config: { },
    schema: { },
    instance: null,
    modalInstance: null,
    errors: { },
    modalErrors: { },
    criteriaEntityName: null,
    formData: null,
    errorModal: false,
  },
  mutations: {
    setAsnOrderLines (state, asnOrderLines) {
      state.asnOrderLines = asnOrderLines
    },
    USER (state, user = { }) {
      state.user = user
    },
    CONFIG (state, config = { }) {
      state.config = config;
    },
    SET_CRITERIA_ENTITY_NAME(state, criteriaEntityName) {
      state.criteriaEntityName = criteriaEntityName
    },
    UPDATE_INSTANCE(state, instance) {
      state.instance = {...state.instance, ...instance}
    },
    UPDATE_MODAL_INSTANCE(state, instance) {
      state.modalInstance = {...state.modalInstance, ...instance}
    },
    SET_INSTANCE(state, instance) {
      state.instance = instance
    },
    SET_MODAL_INSTANCE(state, instance) {
      state.modalInstance = instance
    },
    SET_ERRORS(state, errors) {
      state.errors = errors
    },
    SET_MODAL_ERRORS(state, errors) {
      state.modalErrors = errors
    },
    SET_ERROR_MODAL(state, value) {
      state.errorModal = value
    },
    SET_INSTANCE_PATH(state, o) {
      if(o.path === null) {
        Vue.set(state, 'instance', {...state.instance, ...o.value})
        return
      }
      o.path = o.path.replace('null.', '')
      set(state.instance, o.path, o.value)
      Vue.set(state, 'instance', {...state.instance})
    },
    SET_MODAL_INSTANCE_PATH(state, o) {
      if(o.path === null) {
        Vue.set(state, 'modalInstance', {...state.modalInstance, ...o.value})
        return
      }
      o.path = o.path.replace('null.', '')
      _.set(state.modalInstance, o.path, o.value)
      Vue.set(state, 'modalInstance', {...state.modalInstance})
    },
    SET_FORM_DATA(state, o) {
      state.formData = o;
    },
    SET_PORTAL_TEMPLATE(state, portal) {
      state.portal = portal;
    },
  },
  actions: {
    setBusinessScope({ commit, state }, scope) {
      const newUser = { ...state.user };
      newUser.user.businessScope = scope;
      newUser.user.businessScopeId = scope.id;
      commit('USER', newUser);
    },
  },
  plugins: [storage]
})
